<template>
  <!-- PC 端 -->
  <template v-if="!isMobile">
    <LoginPage v-if="!loggedIn" @success="onLoginSuccess" />
    <div v-else>
      <LogisticsList @logout="onLogout" />
    </div>
  </template>

  <!-- 移动端 -->
  <template v-else>
    <MobileLoginPage v-if="!loggedIn" @success="onLoginSuccess" />
    <MobileHome v-else @logout="onLogout" />
  </template>
</template>

<script>
import { ref, onMounted } from 'vue'
import LoginPage from './components/LoginPage.vue'
import LogisticsList from './components/LogisticsList.vue'
import MobileLoginPage from './components/MobileLoginPage.vue'
import MobileHome from './components/MobileHome.vue'

export default {
  name: 'App',
  components: {
    LoginPage,
    LogisticsList,
    MobileLoginPage,
    MobileHome
  },
  setup() {
    const loggedIn = ref(false)
    const isMobile = ref(false)

    // 检测是否为移动端
    const checkMobile = () => {
      isMobile.value = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
    }

    // 检查本地存储的 token
    const checkToken = () => {
      const token = localStorage.getItem('token')
      const expireAt = localStorage.getItem('expireAt')

      if (token && expireAt) {
        const expireDate = new Date(expireAt)
        if (expireDate > new Date()) {
          loggedIn.value = true
          return
        }
      }

      // token 过期或不存在，清除
      localStorage.removeItem('token')
      localStorage.removeItem('userName')
      localStorage.removeItem('expireAt')
      loggedIn.value = false
    }

    const onLoginSuccess = () => {
      loggedIn.value = true
    }

    const onLogout = () => {
      localStorage.removeItem('token')
      localStorage.removeItem('userName')
      localStorage.removeItem('expireAt')
      loggedIn.value = false
    }

    onMounted(() => {
      checkMobile()
      checkToken()
    })

    return {
      loggedIn,
      isMobile,
      onLoginSuccess,
      onLogout
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

/* PC 端样式 */
.pc-view {
  min-height: 100vh;
  background: linear-gradient(180deg, #f7f9fc 0%, #f2f5fb 100%);
}

/* 移动端样式 */
.mobile-view {
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
  /* 去掉移动端点击时的灰色高亮方框 */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}
</style>
